import { render, staticRenderFns } from "./OfferPartSubscriptionDescriptions.vue?vue&type=template&id=3ddb6d2c&scoped=true&"
import script from "./OfferPartSubscriptionDescriptions.vue?vue&type=script&lang=js&"
export * from "./OfferPartSubscriptionDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./OfferPartSubscriptionDescriptions.vue?vue&type=style&index=0&id=3ddb6d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb6d2c",
  null
  
)

export default component.exports